import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LayoutUtilsService } from '../../../../core/_base/crud';

@Component({
  selector: 'app-chat-share-popup',
  templateUrl: './chat-share-popup.component.html',
  styleUrls: ['./chat-share-popup.component.scss'],
})
export class ChatSharePopupComponent {
  title: string = '';
  constructor(
    private readonly layoutUtilsService: LayoutUtilsService,
    public dialogRef: MatDialogRef<ChatSharePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { runId: string; title: string }
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.title) {
      this.title = this.data.title.length > 100 ? this.data.title.substring(0, 100) + '...' : this.data.title;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
  copyShareLink(): void {
    const shareUrl = `${window.location.origin}/web/genai/share?run_id=${this.data.runId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      this.layoutUtilsService.showActionNotification(`Link Copied`);
    }).catch(err => {
      this.layoutUtilsService.showActionNotification(`Failed to copy link`);
    });
  }
}

